module.exports = __webpack_public_path__ + "media/images/icons/icons_small/2_dish-18e90b6ab33ff296af0b4d03f0b21bc0.png";